export type BdcFileKind = "ORDS" | "PICKLST" | "UNKNOWN";

/** The EDI files are named ORDS_… and PICKLST_…; anything else is still sent, the API decides. */
export const fileKindOf = (name: string): BdcFileKind => {
  const upper = name.toUpperCase();
  if (upper.startsWith("ORDS")) return "ORDS";
  if (upper.startsWith("PICKLST")) return "PICKLST";
  return "UNKNOWN";
};

export const FILE_KIND_LABEL: Record<BdcFileKind, string> = {
  ORDS: "Order (PO)",
  PICKLST: "Pack list (รายร้าน)",
  UNKNOWN: "ไม่รู้จักชนิดไฟล์",
};

export const isTxtFile = (file: File) => file.name.toLowerCase().endsWith(".txt");

/** Add newly picked files to the list; a file with the same name replaces the earlier pick. */
export const mergeFiles = (current: File[], picked: File[]): File[] => {
  const byName = new Map(current.map((file) => [file.name, file]));
  picked.forEach((file) => byName.set(file.name, file));
  return Array.from(byName.values()).sort((a, b) => a.name.localeCompare(b.name));
};
